import React from 'react'
import AlbumList from "../components/AlbumList/AlbumList"
function AlbumPage() {
    return (
    <>
    <AlbumList />
    </>
  )
}

export default AlbumPage